import { defineStore } from 'pinia'

export const useRoiRefreshStore = defineStore('roiRefresh', {
  state: () => ({ isDirty: false }),
  actions: {
    markDirty() { this.isDirty = true },
    clearDirty() { this.isDirty = false }
  }
})
